<template>
  <div class="cha-scope">
    <div
      v-if="loading"
      class="cha-empty"
    >加载中...</div>
    <div
      v-else-if="!logs.length"
      class="cha-empty"
    >暂无记录</div>
    <div
      v-else
      class="timeline"
    >
      <div
        v-for="item in logs"
        :key="item.code"
        class="timeline-item"
      >
        <div class="timeline-title">
          <span>{{ item.title || item.action }}</span>
          <time>{{ fmtTime(item.operatedAt) }}</time>
        </div>
        <div>{{ item.content }}</div>
        <div class="hint">操作人：{{ item.operatorName || "--" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChannelTimeline",
  props: {
    logs: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    fmtTime(value) {
      if (!value) {
        return "--";
      }
      return String(value).replace("T", " ").slice(0, 19);
    }
  }
};
</script>